import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { Box, Grid, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import SearchForms from "../Forms/SearchForms";
import { getPrintgroupsFromStores } from "../../store/articles/ArticlesHelpers";
import articlesStore from "../../store/articles/ArticlesStore";
import { getArticles } from "../../store/articles/ArticlesApi";
import cloudStore from "../../store/CloudStore";

const printTagSettings = ["NORMAL", "A_A", "ONE_ONE"];

function PrinterTags(props) {
  const printer = props.printer;
  const [printerTags, setPrinterTags] = React.useState([...printer.printer_tags]);
  const [newPrinterSetting, setNewPrinterSetting] = React.useState("NORMAL");
  const [printgroupsFromStore, setPrintgroupsFromStore] = React.useState(null);
  const [articlesLoaded, setArticlesLoaded] = React.useState(!!articlesStore.articles);

  useEffect(() => {
    if (!articlesLoaded) {
      getArticles(cloudStore.merchant.id);
    }
  }, []);

  useEffect(() => {
    if (articlesStore.articles != null) {
      setPrintgroupsFromStore(getPrintgroupsFromStores());
    }
  }, [articlesLoaded]);

  function onChangeArticles() {
    setArticlesLoaded(true);
  }

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    };
  }, []);

  return (
    <>
      <Grid item xs={12} container spacing={1} style={{ maxWidth: 480 }} alignContent={"center"} alignItems={"center"}>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "print_groups" })}</Box>
          </Typography>
        </Grid>

        {printerTags.map((printerTag, index) => {
          return (
            <>
              <Grid item xs={1}>
                <IconButton
                  size={"small"}
                  onClick={() => {
                    printerTags.splice(index, 1);
                    setPrinterTags([...printerTags]);
                    props.setPrinterTags([...printerTags]);
                  }}
                >
                  <Close />
                </IconButton>
              </Grid>
              <Grid item xs={11}>
                {printerTag.tag} - {props.intl.formatMessage({ id: "print_setting_" + printerTag.setting })}
              </Grid>
            </>
          );
        })}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "add_print_group" })}</Box>
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Select
            style={{ width: "100%" }}
            value={newPrinterSetting}
            onChange={(e) => {
              setNewPrinterSetting(e.target.value);
            }}
          >
            {printTagSettings.map((setting) => {
              return (
                <MenuItem value={setting}>{props.intl.formatMessage({ id: "print_setting_" + setting })}</MenuItem>
              );
            })}
          </Select>
        </Grid>
        {printgroupsFromStore && (
          <Grid item xs={6}>
            <SearchForms
              createOption={(searchValue) => ({ name: searchValue })}
              placeholder={props.intl.formatMessage({ id: "select_printgroup" })}
              allResults={printgroupsFromStore.map((printgroup) => ({
                name: printgroup,
              }))}
              handleSelect={(option) => {
                if (!printerTags.some((tag) => tag.tag === option.name)) {
                  printerTags.push({ tag: option.name, setting: newPrinterSetting, printer_id: props.printer.id });
                  setPrinterTags([...printerTags]);
                  props.setPrinterTags([...printerTags]);
                }
              }}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default withIntl(PrinterTags);
